import styled from 'styled-components';
import Container from '../Container/Container';

export const ArchitectContainer = styled(Container)`
  color: #fff;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  span {
    font-size: 40px;
    font-weight: 300;
    color: #fff;
  }
  .bold {
    font-weight: 700;
  }
`;

export const Content = styled.div`
  padding: 16px 16px 16px 32px;
  line-height: 32px;
  border-left: 1px solid #fff;
  color: #fff;
`;
